/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
import * as i0 from "./title-bar.component.scss.shim.ngstyle";
import * as i1 from "@angular/core";
import * as i2 from "./title-bar.component";
var styles_TitleBarComponent = [i0.styles];
var RenderType_TitleBarComponent = i1.ɵcrt({ encapsulation: 0, styles: styles_TitleBarComponent, data: {} });
export { RenderType_TitleBarComponent as RenderType_TitleBarComponent };
export function View_TitleBarComponent_0(_l) { return i1.ɵvid(2, [(_l()(), i1.ɵeld(0, 0, null, null, 3, "div", [["class", "title-bar"]], null, null, null, null, null)), (_l()(), i1.ɵeld(1, 0, null, null, 2, "div", [["class", "container"]], null, null, null, null, null)), (_l()(), i1.ɵeld(2, 0, null, null, 1, "h1", [], null, null, null, null, null)), (_l()(), i1.ɵted(3, null, ["", ""]))], null, function (_ck, _v) { var _co = _v.component; var currVal_0 = _co.pageTitle; _ck(_v, 3, 0, currVal_0); }); }
export function View_TitleBarComponent_Host_0(_l) { return i1.ɵvid(0, [(_l()(), i1.ɵeld(0, 0, null, null, 1, "lp2-title-bar", [], null, null, null, View_TitleBarComponent_0, RenderType_TitleBarComponent)), i1.ɵdid(1, 49152, null, 0, i2.TitleBarComponent, [i1.ElementRef], null, null)], null, null); }
var TitleBarComponentNgFactory = i1.ɵccf("lp2-title-bar", i2.TitleBarComponent, View_TitleBarComponent_Host_0, { pageTitle: "pageTitle" }, {}, []);
export { TitleBarComponentNgFactory as TitleBarComponentNgFactory };
//# sourceMappingURL=title-bar.component.ngfactory.js.map


//////////////////
// WEBPACK FOOTER
// ./ts/app/shared/title-bar/title-bar.component.ngfactory.js
// module id = 818
// module chunks = 27 28 29